<template>
    <dd
        :class="{
            'break-words': true,
            'text-base font-bold text-primary': theme === Theme.Normal,
            'text-lg text-secondary': theme === Theme.Primary,
        }"
        data-spec-class="description-list-data"
    >
        <slot />
    </dd>
</template>

<script setup lang="ts">
import { withDefaults, defineProps } from 'vue';
import { Theme } from '@/types';

interface Props {
    theme?: Theme;
}

withDefaults(defineProps<Props>(), {
    theme: Theme.Normal,
});
</script>
